<template>
  <dialog :open="isOpen" class="default-dialog" @click="closeModal">
    <div class="dialog-content" @click.stop>
      <header class="dialog-header">
        <div>
          <h2 class="dialog-title">{{ title }}</h2>
        </div>
        <button @click="closeModal" class="close-icon-button">✖</button>
      </header>

      <main class="dialog-body">
        <div class="quote-form">
          <div class="input-group input-group-outline m-0 d-flex flex-column">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Client id</span
              >
              <input
                v-model="pay2m.client_id"
                type="text"
                class="form-control default-bordered-input"
              />
            </label>
          </div>

          <div class="input-group input-group-outline m-0 d-flex flex-column">
            <label class="input-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Client secret</span
              >
              <input
                v-model="pay2m.client_secret"
                type="text"
                class="form-control default-bordered-input"
              />
            </label>
          </div>

          <div class="switch-field">
            <label class="switch-label">
              <span class="text-xs text-uppercase text-body font-weight-bolder"
                >Repassar taxa</span
              >
              <InputSwitch v-model="pay2m.pass_fee" />
            </label>
          </div>

          <div class="button-field">
            <button
              @click="save"
              class="btn submit-button"
              :disabled="!isFieldsFilled"
            >
              Salvar
            </button>
            <button @click="closeModal" class="btn cancel-button">
              Cancelar
            </button>
          </div>
        </div>
      </main>
    </div>
  </dialog>
</template>

<script>
import { vMaska } from "maska/vue";
import InputSwitch from "primevue/inputswitch";

export default {
  components: {
    InputSwitch,
  },
  directives: {
    maska: vMaska,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    receivedPay2m: {
      type: Object,
      default: () => ({
        client_id: "",
        client_secret: "",
        pass_fee: false,
      }),
    },
  },
  data() {
    return {
      title: "Configuração Pay2m",
      pay2m: {
        client_id: this.receivedPay2m?.client_id || "",
        client_secret: this.receivedPay2m?.client_secret || "",
        pass_fee: this.receivedPay2m?.pass_fee || false,
      },
    };
  },
  watch: {
    receivedPay2m: {
      handler(newPay2m) {
        if (newPay2m && Object.keys(newPay2m).length > 0) {
          this.pay2m = {
            client_id: newPay2m?.client_id || "",
            client_secret: newPay2m?.client_secret || "",
            pass_fee: newPay2m?.pass_fee || false,
          };
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    save() {
      if (this.pay2m) {
        this.$emit("update:pay2mForm", this.pay2m);
        this.$emit("updatePayment");
        this.closeModal();
      } else {
        alert("Por favor, preencha todos os campos.");
      }
    },
    resetForm() {
      this.pay2m = {
        client_id: "",
        client_secret: "",
        pass_fee: false,
      };
    },
  },
  computed: {
    isFieldsFilled() {
      return (
        this.pay2m?.client_id?.trim() !== "" &&
        this.pay2m?.client_secret?.trim() !== ""
      );
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999999;
  background: none;
  backdrop-filter: blur(4px);
  background-color: rgba(0, 0, 0, 0.2);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

dialog::backdrop {
  backdrop-filter: blur(2px);
  animation: fadein 0.2s linear;
}

.dialog-content {
  width: 600px;
  max-width: 100%;
  max-height: 90%;
  overflow: auto;
  background: white;
  border-radius: 8px;
  padding: 20px;
  z-index: 2;
  transform: scale(0.96);
  transition: transform 0.2s;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

dialog[open] .dialog-content {
  transform: scale(1);
}

.dialog-title {
  font-family: sans-serif;
  font-size: 26px;
  color: #111111;
  margin: 0;
}

.modal-overlay {
  position: fixed;
  display: flex;
  top: 0;
  align-items: center;
  justify-self: center;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(144, 149, 160, 0.5);
  color: #9095a0;
  z-index: 9999999;
  backdrop-filter: blur(4px);
  width: 100vw;
  height: 100vh;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.dialog-body {
  margin: 20px 0 0 0;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
}

.button-field {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  margin-top: 10px;
}

.cancel-button {
  background-color: #e0e0e0;
  color: #0f172a;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  margin-bottom: 0;

  &:hover {
    background-color: #d6d6d6;
    color: #0f172a;
  }
}

.close-icon-button {
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

.submit-button {
  background-color: #661cb0;
  color: white;
  display: flex;
  height: 40px;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 6px;
  line-height: 0;
  position: relative;
  transition: background-color 0.2s ease;
  cursor: pointer;
  margin-bottom: 0;

  &:hover {
    background-color: #7b23d3;
    color: white;
  }
}

.quote-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.quote-form input {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
}

.awarded-quotes-list {
  list-style: none;
  padding: 0;
  margin: 20px 0 0;
}

.awarded-quotes-item {
  border: 1px solid #d2d6da !important;
  padding: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 4px;
  color: #36454f;
}

.quote-number {
  display: flex;
  gap: 5px;
  align-items: center;
}

.no-quotes {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  margin: 40px 0 40px 0;
  color: #3c3d42;
}

.remove-quote-btn {
  border: none;
  background-color: transparent;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.switch-field {
  margin: 10px 0;
}

.switch-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>